"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withOneTrust = exports.default = exports.CATEGORY = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const URL = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
const CATEGORY = exports.CATEGORY = {
  C0001: 'C0001',
  C0002: 'C0002',
  // mixpanel
  C0003: 'C0003',
  C0004: 'C0004',
  C0005: 'C0005',
  C0006: 'C0006',
  C0007: 'C0007',
  // hotjar, sentry
  C0008: 'C0008' // fingerprint
};
const withSuffix = (id, env) => {
  switch (env) {
    case 'production':
    case 'prod':
      return id;
    default:
      return `${id}-test`;
  }
};
const getOneTrustId = siteId => {
  switch (siteId) {
    case 1:
      return '96033a43-b4a6-42a7-acd0-c1fa033e95cc';
    case 2:
      return 'e97c38a9-995f-4113-8856-4038ae6d8152';
    case 3:
      return 'cf80f426-9d4a-41a8-802d-84998898244f';
    case 4:
      return '7d692c2d-6049-4fa5-a6a8-125ab211dc86';
    case 7:
      return 'ad42a790-506e-452f-b968-7e25ec6be129';
    case 66:
      return 'b4d197e7-a7be-4e0b-af9e-4f72a6becacd';
    case 69:
      return '929bc1ff-01d6-4991-8ad7-24dd6fd26532';
    case 70:
      return '05fe2809-b98e-4505-a7a3-1bed66436d89';
    case 71:
      return '05fe2809-b98e-4505-a7a3-1bed66436d89';
    case 73:
      return '0d4717d0-337e-40e7-a622-e5e2bfc71575';
    case 76:
      return 'a9247576-4d77-46aa-bb09-89a70a9b070c';
    case 105:
      return '2a68e640-6917-497b-9575-26ae95cd39f7';
    default:
      return undefined;
  }
};
const getLang = siteId => {
  switch (siteId) {
    case 1: // france
    case 70: // belgium fr
    case 73:
      // luxembourg fr
      return 'fr';
    case 2: // germany
    case 7:
      // austria
      return 'de';
    case 3: // spain
    case 66:
      // spain privalia
      return 'es';
    case 4: // italy
    case 69:
      // italy privalia
      return 'it';
    case 71: // belgium nl
    case 76:
      // netherlands
      return 'nl';
    default:
      return 'en';
  }
};
const parseGroups = activeGroupsString => activeGroupsString && activeGroupsString.split(',');
const isGroupActive = (activeGroups, group) => activeGroups?.includes(group);
const withOneTrust = (callback, category, removeCallback = undefined) => {
  if (typeof window === 'undefined') return;
  try {
    // called once
    window.OneTrust?.InsertHtml?.(null, null, callback, null, category);

    // called on every re-consent
    const oldOptanonWrapper = window.OptanonWrapper;
    window.OptanonWrapper = () => {
      if (oldOptanonWrapper) oldOptanonWrapper();
      window.OneTrust?.InsertHtml(null, null, callback, null, category);
      if (removeCallback && !isGroupActive(parseGroups(window.OnetrustActiveGroups), category)) removeCallback();
    };
  } catch {
    return;
  }
};
exports.withOneTrust = withOneTrust;
const OneTrust = ({
  siteId,
  env
}) => {
  if (!siteId) return null; // NOTE: preventing any side-effect by not rendering

  const oneTrustId = getOneTrustId(siteId);
  if (!oneTrustId) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
    src: URL,
    type: "text/javascript",
    "data-language": getLang(siteId),
    "data-domain-script": withSuffix(oneTrustId, env)
  });
};
var _default = exports.default = OneTrust;